import { stringToRegExp } from '../../../helpers/stringToRegexp';
import { IProductAssignment, IProductsTransferListObject } from '../types';

export const filterByName = (
    items: IProductAssignment[],
    name: string
): IProductAssignment[] => {
    if (name === '') {
        return items;
    }
    return items.filter((item) => lowerCaseFilter(item, name));
};

export const lowerCaseFilter = (object: IProductAssignment, name: string) => {
    return object.name.toLowerCase().match(stringToRegExp(name.toLowerCase()));
};

export const filterObjects = (
    items: IProductAssignment[],
    name: string
): IProductAssignment[] => {
    return filterByName(items, name);
};
export function not<T extends IProductsTransferListObject>(a: T[], b: T[]) {
    const bSet = new Set(b.map((item) => item.relationId));

    return a.filter((item) => !bSet.has(item.relationId));
}

export function intersection<T extends IProductsTransferListObject>(
    a: T[],
    b: T[]
) {
    const bSet = new Set(b.map((item) => item.relationId));

    return a.filter((item) => bSet.has(item.relationId));
}

export function findIndexById<T extends IProductsTransferListObject>(
    a: T[],
    b: T
) {
    return a.findIndex((el) => el.relationId === b.relationId);
}

export function union<T extends IProductsTransferListObject>(a: T[], b: T[]) {
    return [...a, ...not(b, a)];
}
